__turbopack_context__.v({
  "button": "InvoiceModalContent-module-scss-module__03etZW__button",
  "contentContainer": "InvoiceModalContent-module-scss-module__03etZW__contentContainer",
  "description": "InvoiceModalContent-module-scss-module__03etZW__description",
  "input": "InvoiceModalContent-module-scss-module__03etZW__input",
});
